import { message } from 'ant-design-vue';

import HttpResponseError from './http/http-response-error';

export type MessageGetter<V, T> = (data: V, error: T) => string;

export default function showMessage<T>(
  error: T,
  cases: Record<number, string | MessageGetter<any, T>> = {},
  fallback = '网络错误，请稍后重试',
) {
  let content = '';

  if (error instanceof HttpResponseError) {
    const getter = cases[error.code];
    content = typeof getter === 'function' ? getter(error.data, error) : getter;
  } else if (error instanceof Error) {
    content = error.message;
  }

  message.error(content ?? fallback);
}
